// extracted by mini-css-extract-plugin
export var aircallIframe = "_ii-3";
export var fabContainer = "_ii-5";
export var fabRinging = "_ii-6";
export var loadingOverlay = "_ii-4";
export var pulse = "_ii-7";
export var widgetContent = "_ii-2";
export var widgetPanel = "_ii-0";
export var widgetPanelExpanded = "_ii-1";